import { Box } from '@mui/material';
import { RenderTable } from '../../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
import { useState } from 'react';
interface IProps {
  moduleData: any;
  tabValue: number;
  isView: boolean;
  // machineData?: any;
  // autoCompleteMachineValue?: any;
  // setAutoCompleteMachineValue?: any;
}

const TController = ({
  moduleData,
  tabValue,
  isView,
}: // machineData,
// autoCompleteMachineValue,
// setAutoCompleteMachineValue,
IProps) => {
  const [controllerRender, setControllerRender] = useState(false);
  return (
    <Box>
      <RenderTable>
        <THead
          {...{
            moduleData,
            tabValue,
            isView,
            // machineData,
            // autoCompleteMachineValue,
            // setAutoCompleteMachineValue,
            setControllerRender,
          }}
        />
        <TBody {...{ moduleData, tabValue, isView }} />
        <TFoot {...{ moduleData, isView }} />
      </RenderTable>
    </Box>
  );
};

export default TController;
